<ng-template #advancedConfiguration>
    <mat-tab-group animationDuration="0ms" class="workspace-adv-config-tab-group">
        <mat-tab [label]="'filterTab' | t">
            <div class="container-fluid">
                <div class="config-filters-area">
                    <div class="config-filter row mb-2">
                        <div class="config-filter-left col-md-6 config-filter-area">
                            <div class="input-group input-group-sm mb-2">
                                <div class="input-group-prepend">
                                    <span class="input-group-text" id="inputGroup-sizing-sm">{{
                                        "column" | t
                                    }}</span>
                                </div>
                                <select
                                    class="form-select custom-select"
                                    [(ngModel)]="configColumn"
                                    id="compareColumn"
                                    (change)="setComparisonTypes()"
                                >
                                    <option value="" selected>
                                        {{ "any" | t }}
                                    </option>
                                    @for (col of allColumns; track col) {
                                        <option [value]="col">
                                            {{ headerLookup[col] }}
                                        </option>
                                    }
                                </select>
                            </div>
                            <div class="input-group input-group-sm mb-2">
                                <div class="input-group-prepend">
                                    <span class="input-group-text" id="inputGroup-sizing-sm">{{
                                        "compareWith" | t
                                    }}</span>
                                </div>
                                <select
                                    class="form-select custom-select"
                                    [(ngModel)]="configCompareType"
                                    id="compareType"
                                >
                                    @for (comp of configComparisonTypes; track comp) {
                                        <option [value]="comp.key">
                                            {{ comp.value }}
                                        </option>
                                    }
                                </select>
                            </div>
                            <div class="input-group input-group-sm mb-2">
                                <div class="input-group-prepend">
                                    <span class="input-group-text" id="inputGroup-sizing-sm">{{
                                        "searchValue" | t
                                    }}</span>
                                </div>
                                <input
                                    type="text"
                                    class="form-control"
                                    [(ngModel)]="configSearchValue"
                                    inputTooltip
                                />
                            </div>
                            <button
                                class="btn btn-outline-secondary float-end"
                                type="button"
                                (click)="addKywrd()"
                            >
                                {{ "addFilter" | t }}
                                <i class="fas fa-caret-right"></i>
                            </button>
                        </div>
                        <div class="config-filter-right col-md-6">
                            @if (configKeywords.length > 0) {
                                <mat-chip-listbox id="sortabletest">
                                    @for (kywrd of configKeywords; track kywrd) {
                                        <mat-chip-option
                                            (removed)="removeKywrd(kywrd)"
                                            (click)="editKywrd(kywrd)"
                                        >
                                            {{ kywrd.searchValue }}
                                            {{
                                                kywrd.col == ""
                                                    ? ""
                                                    : "[" + headerLookup[kywrd.col] + "]"
                                            }}
                                            <mat-icon matChipRemove>cancel</mat-icon>
                                        </mat-chip-option>
                                    }
                                </mat-chip-listbox>
                            } @else {
                                <div class="no-filter-message">
                                    <span>{{
                                        "noFiltersSpecified" | t
                                    }}</span>
                                </div>
                            }
                        </div>
                    </div>
                    <hr />
                    @for (filter of filterConfig; track filter) {
                        <div class="mb-2">
                            @if (dataFilter[filter.column]) {
                                <div>
                                    <div class="form-group">
                                        <label>{{
                                            (filter.label
                                                ? filter.label
                                                : headerLookup[filter.column]) +
                                                (filter.remoteFilter ? " *" : "")
                                        }}</label>
                                        @switch (filter.component) {
                                            @case (filterComponent.SingleSelectTree) {
                                                <cerrix-select-tree
                                                    #specificTree
                                                    [identifier]="filter.identifier"
                                                    [tree]="dataFilter[filter.column]"
                                                    [value]="
                                                        filters[filter.column]
                                                            ? filters[filter.column]
                                                            : null
                                                    "
                                                    [multiselect]="false"
                                                    (onChange)="setTreeValue(filter.column, $event)"
                                                >
                                                </cerrix-select-tree>
                                            }
                                            @case (filterComponent.MultiSelectTree) {
                                                <cerrix-select-tree
                                                    #specificTree
                                                    [identifier]="filter.identifier"
                                                    [tree]="dataFilter[filter.column]"
                                                    [value]="
                                                        filters[filter.column]
                                                            ? filters[filter.column]
                                                            : []
                                                    "
                                                    [multiselect]="true"
                                                    (onChange)="setTreeValue(filter.column, $event)"
                                                >
                                                </cerrix-select-tree>
                                            }
                                            @case (filterComponent.ComboBox) {
                                                <ng-select
                                                    #combobox
                                                    [id]="filter.identifier"
                                                    [items]="dataFilter[filter.column]"
                                                    bindLabel="Name"
                                                    bindValue="ID"
                                                    [appendTo]="ngSelectHolderSelector"
                                                    (change)="
                                                        setDropdownValue(filter.column, $event)
                                                    "
                                                >
                                                </ng-select>
                                            }
                                        }
                                    </div>
                                </div>
                            } @else {
                                <div>
                                    <i class="fas fa-circle-notch fa-spin me-2"></i>{{
                                        "loadingFilter"
                                            | t: { label: filter.label }
                                    }}
                                </div>
                            }
                        </div>
                    }
                    @if (hasServerFilters) {
                        <small class="modal-body-info">
                            {{ "remoteFilterNote" | t }}
                        </small>
                    }
                </div>
            </div>
        </mat-tab>
        @if (showTableConfiguration) {
            <mat-tab [label]="'tableTab' | t">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col">
                            <div class="header-header bolded">
                                {{ "activeHeaders" | t }}
                            </div>
                            <ejs-listbox
                                [dataSource]="shownHeaderData"
                                [allowDragAndDrop]="true"
                                [fields]="setfield"
                                scope="combined-list"
                                (drop)="onDropSetHidden($event)"
                                (click)="toggleHeader($event, true)"
                                #activeListbox
                            ></ejs-listbox>
                        </div>
                        <div class="col">
                            <div class="header-header bolded">
                                {{ "hiddenHeaders" | t }}
                            </div>
                            <ejs-listbox
                                [dataSource]="hiddenHeaderData"
                                [allowDragAndDrop]="true"
                                [fields]="setfield"
                                scope="combined-list"
                                (click)="toggleHeader($event, false)"
                                (drop)="onDropSetActive($event)"
                                #hiddenListbox
                            ></ejs-listbox>
                        </div>
                    </div>
                </div>
            </mat-tab>
        }
    </mat-tab-group>
</ng-template>
